module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_fds_m_en.e35a8985b1f9bac876e7e50dc5f3dca3.png";